{
    "Profile_CommonComponents_Risks.limit": "Limit",
    "Profile_CommonComponents_Risks.deductible": "Deductible",
    "Profile_CommonComponents_Risks.price": "Price",
    "Profile_CommonComponents_Risks.amount": "Amount",
    "Profile_CommonComponents_Risks.premium_total": "Premium Total",
    "Profile_CommonComponents_Risks.taxes": "Taxes",
    "Profile_CommonComponents_Risks.subtotal": "SubTotal",
    "Profile_CommonComponents_Risks.surcharges": "Surcharges",
    "Profile_CommonComponents_Risks.discount": "Discount",
    "Profile_CommonComponents_Risks.discounts": "Discounts",
    "Profile_CommonComponents_Risks.fees": "Fees",
    "Profile_CommonComponents_Risks.grand_total": "Grand Total",
    "Profile_CommonComponents_Risks.mainCoverage": "Main Coverage",
    "Profile_CommonComponents_Risks.extraProtection": "Extra Protection"
}
